import AceEditor from "react-ace";
import { useEffect, useState } from "react";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-tomorrow";

export default function Body({ value, onChange, onBlur }) {
  return (
    <AceEditor
      mode="json"
      theme="tomorrow"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      name="bodyDiv"
      debounceChangePeriod={300}
      editorProps={{ $blockScrolling: true }}
      setOptions={{
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        enableSnippets: false,
        showLineNumbers: true,
        tabSize: 2,
      }}
      style={{ width: "100%", height: 200, border: "1px solid #E0E0E0" }}
    />
  );
}
